exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fare-card[data-v-4bd0f106]{border-radius:14px}.feature-row[data-v-4bd0f106]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;padding:2px 0}.feature-label[data-v-4bd0f106]{font-weight:600;color:#6b6b6b}.feature-value[data-v-4bd0f106]{text-align:right}.bullet-list[data-v-4bd0f106]{margin:0 0 8px 16px;padding-left:12px}.bullet-list li[data-v-4bd0f106]{margin:2px 0}", ""]);

// exports
